module.exports = __webpack_public_path__ + "img/Arrow-Coverage-Light.ca25628.svg";